/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecommendationExtras {
    getFixupPrototypeFunction() { return ResourceRecommendationExtras.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecommendationExtras>): ResourceRecommendationExtras {
        let obj = Object.assign(new ResourceRecommendationExtras(), model);
        ResourceRecommendationExtras.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecommendationExtras>): ResourceRecommendationExtras {
        if (!model) return null;
        return ResourceRecommendationExtras.newInstance(<ResourceRecommendationExtras> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecommendationExtras) {
        if (!obj) return;

        models.ResourceRecommendationExtras.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecommendationExtras): boolean {
        Object.setPrototypeOf(obj, ResourceRecommendationExtras.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.touched_at === "string") {
            this.touched_at = new Date(<string><any>this.touched_at);
        }
        if (this.audits) {
            models.RecommendationAudits.fixupPrototype(this.audits);
        }
        if (this.additional_resource_details) {
            models.AdditionalResourceDetailsBase.fixupPrototype(this.additional_resource_details);
        }
        if (this.utilization_metrics) {
            for (let val of this.utilization_metrics) {
                models.UtilizationMetricsForRecommendation.fixupPrototype(val);
            }
        }
    }

    audits: models.RecommendationAudits;

    /**
     * recommendation_id
     */
    recommendation_id: string;

    /**
     * Boolean to describe the recommendation is preidentified or not
     */
    is_preidentified: boolean;

    utilization_metrics: Array<models.UtilizationMetricsForRecommendation>;

    /**
     * Document updated Time
     */
    touched_at: Date;

    additional_resource_details: models.AdditionalResourceDetailsBase;

}
